import { MainExportsComponent } from "./components/main-exports.component";
import {RouterModule, Routes} from "@angular/router";
import { NgModule } from '@angular/core';
import { AuthService } from '../../injections/auth.service';

export const appRoutes: Routes = [
    {
        path: 'exports',
        component: MainExportsComponent,
        canActivate: [AuthService]
    },
    
];


@NgModule({
    imports: [
        RouterModule.forChild(appRoutes)
    ],
    exports: [
        RouterModule
    ],
    declarations: [],
    providers: [],
})
export class ExportsRoutes { }


// WEBPACK FOOTER //
// ./src/app/modules/exports/exports.routes.ts